// src/config/app-branding.js

export const APP_BRANDING = {
  name: "CORE TALENTO", // Sugerencia de nombre: CORE TALENTO, NexusHR, FlowTalento
  shortName: "CORE",
  slogan: "Gestión Inteligente de Personal",
  tagline: "HR MANAGEMENT SYSTEM",
  version: "2.0.0"
};